import React, { useState,useEffect } from 'react';
import { Container,Row,Col,Placeholder, Card } from 'react-bootstrap';
const AlumniMeet = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Miscellaneous,setMiscellaneous]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousByTypeAll = async () => 
        {
            setLoading(true);
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/byTypeAll/"+22);
                const result = await response.json();
                setMiscellaneous(result);
                setLoading(false);
                if( global.config.IsPrint === true ) { console.info('MiscellaneousByTypeAll : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousByTypeAll : Error', error.message);
            }
        };
        MiscellaneousByTypeAll();   
    },[])
    return (        
        <Container className="py-md-5 py-4 text-center">
            <h2 className='text-uppercase'>{appLanguage === 'hi' ? "पूर्व छात्र मिलन समारोह 2022" : "Alumni Meet 2022"}</h2>
            <span className="mb-4 sub-heading"></span>
            {isLoading ? (
            <Row className="row-cols-1 row-cols-sm-2 row-cols-md-2 g-3">
            {[...Array(6)].map((_,index)=>(
                <Col key={index}>
                    <Card className='bg-info'>
                        <Card.Body>
                            <div className="ratio ratio-4x3" data-aos="flip-up" data-aos-duration="1000">
                                <Placeholder className="w-100 h-100" />
                            </div>
                        </Card.Body>
                    </Card>                    
                </Col>
            ))}
            </Row>  
            ) : (
            <Row className="row-cols-1 row-cols-sm-2 row-cols-md-2 g-3">
            {Miscellaneous.map((sm,index)=>(
                <Col key={index}>
                    <Card className='bg-info-subtle'>
                        <Card.Body>
                            <div className="ratio ratio-4x3 overflow-hidden" data-aos="flip-up" data-aos-duration="1000">
                                <iframe src={sm.sm_link+'?rel=0&cc_load_policy=1'} title={appLanguage === 'hi' ? sm.sm_name_hi || sm.sm_name : sm.sm_name} allowFullScreen></iframe>
                            </div>
                        </Card.Body>
                    </Card>                    
                </Col>
            ))}
            </Row>
        )}
        </Container>        
    );    
}
export default AlumniMeet;